// Build inline JSON nodes (text + hardBreak) from an array of line strings
// Suitable for TipTap editor.chain().insertContent(JSON)
// marks: optional array of mark JSON objects (e.g. [{ type: "inserted" }]) to apply to text nodes
export function buildInlineJsonFromLines(lines, marks = null) {
  const inline = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    if (line && line.length > 0) {
      const node = { type: "text", text: line };
      if (marks) node.marks = marks;
      inline.push(node);
    }
    if (i < lines.length - 1) inline.push({ type: "hardBreak" });
  }
  return inline;
}

// Build inline ProseMirror nodes (text + hardBreak) from an array of line strings
// Suitable for constructing Fragment/Slice with real PM nodes
// marks: optional array of ProseMirror Mark instances to apply to text nodes
export function buildPmInlineNodesFromLines(editor, lines, marks = null) {
  const inline = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    if (i > 0) inline.push(editor.schema.nodes.hardBreak.create());
    if (line && line.length > 0) {
      inline.push(marks ? editor.schema.text(line, marks) : editor.schema.text(line));
    }
  }
  return inline;
}
